import { emptyObj } from '@beef/utils';
import { createMergedBlockSelector } from "../../selectors";
import { getAdditionalServicesBlock } from "../selectors";
var getAdditionalServicesData = createMergedBlockSelector(getAdditionalServicesBlock);
export var getAdditionalServicesContent = function getAdditionalServicesContent(state) {
  return getAdditionalServicesData(state) || emptyObj;
};